import React from 'react';
import Paragraph from '../Paragraph';

import './style.css';

const Content = () => {
  return (
    <div className="Content">
      <Paragraph>
        <b>
          Congratulations on your decision to increase the comfort level, value
          and appearance of your home. To maximize your investment and enable
          the installation to take place as smoothly as possible, we have
          created this handout to acquaint you with what to expect when our
          installers arrive.
        </b>
      </Paragraph>

      <Paragraph>
        <b>1. Expected Delivery Time. </b>
        Installation of windows is scheduled in the order of contract date
        unless otherwise specified. Window World will install all contracted
        work at the earliest possible date. Window World however, will not be
        held responsible for delays caused by weather, manufacture delays,
        re-measures, customer rescheduling, or any other cause outside the
        control of Window World.
      </Paragraph>

      <Paragraph>
        <b>2. Access to the Windows and Doors.</b>
        We will need approximately 2 feet in front of each window, inside your
        home, so we can place our drop cloths and tools necessary to perform our
        work. When the old windows are removed, gusts of wind typically flow
        through your home. It is advisable to gather together important papers,
        and other small items that can be disturbed by the wind and relocate
        them. Computers and other electronic equipment should be covered or
        relocated temporarily. Please move aside any furnishings that are in the
        way of our work.
        <b>
          If any furniture items are too heavy to move easily, we will gladly
          assist you.
        </b>
      </Paragraph>

      <Paragraph>
        <b>3. Window Coverings.</b>
        To gain access to the interior of the windows, we need all mini blinds,
        vertical blinds, roll-up shades, shutters, drapes and any other window
        covering removed prior to our installation.
        <b>
          We are not responsible for removing or reinstallation of these items
          and are not responsible for damage resulting in the removal and
          reinstallation. We also are not responsible for any window covering
          alterations that may be required to reinstall them.
        </b>
      </Paragraph>

      <Paragraph>
        <b>4. Plants and Bushes.</b>
        Occasionally we need to work in planters and other landscaped areas of
        your home that are adjacent to the windows and doors. Please survey your
        yard prior to us arriving and look for potential problems. Some trees
        and vigorous bushes need to be pruned back to give us access to your
        windows.
        <b>
          Delicate plants and shrubs in areas right below a window should be
          temporarily relocated if they cannot survive being stepped on and you
          want to preserve them.
        </b>
        We strive to be careful when working around vegetation, but our
        priorities are to focus on our work, your windows and our safety while
        working on your property.
        <b>
          We are not responsible for any damage to plants, shrubs or landscaped
          areas.
        </b>
      </Paragraph>

      <Paragraph>
        <b>5. Arrival and Departure Times.</b>
        We will advise you of the expected arrival time for our crew at the time
        we set up the installation date with you. We generally stay till the job
        is done, unless it will be a 2 or 3-day job, in which case we may work
        as long as there is daylight.
        <b>
          It is our policy that our installers get a sign-off form and collect
          the outstanding balance at the completion of the job. We ask that you
          be available to approve the job and make final payment at the time of
          completion. If this is not convenient for you, we need to know before
          we start the job. Inclement weather and other unforeseen hindrances
          are a fact of life and as such we ask that you understand if the
          weather, traffic, etc. cause a delay or cancellation of an
          installation appointment. We typically do not schedule more than a day
          or two in advance to try to avoid such issues.
        </b>
      </Paragraph>

      <Paragraph>
        <b>6. Our Worksite.</b>
        We like to set up our worksite as close to your windows and doors as
        possible and generally your driveway is the best spot. If using the
        driveway will block a garaged car, please be ready to pull it out upon
        arrival.
      </Paragraph>

      <Paragraph>
        <b>7. Alarm Systems.</b>
        For those of you who have alarm systems, the alarm company should be
        notified and advised of our job. They will be responsible for the
        disconnection and reconnection of your alarm system.
      </Paragraph>

      <Paragraph>
        <b>8. Where do we start?</b>
        Upon arrival, the crew leader will survey the job and determine where to
        begin. If you have a preference, feel free to advise us and we will
        accommodate to the best of our ability. Because we work in stages (i.e.,
        removal of old windows, setting the new window, wrapping of exterior,
        etc.), we don’t complete the job one window at a time. The job moves
        along in a rolling progression where each operation is done on all
        windows at the same time. This produces a quality job.
      </Paragraph>

      <Paragraph>
        <b>
          9. If the job takes more than a day, will there be any openings in my
          house?
        </b>
        Of course not. We only remove that which can be reinstalled in the same
        day. Although there may not be a complete window, it will be
        weather-tight and secure for overnight. (Please no critiquing at this
        time).
      </Paragraph>

      <Paragraph>
        <b>10. Pets.</b>
        We love furry, four-legged creatures; however, we need your help in
        supervising them. We are not always able to close a gate or door behind
        us when carrying a window, so please keep them in a safe place. Our job
        description does not include scampering down the street after Fido with
        new found freedom. Many people say, don‘t worry, he doesn’t bite, but
        many installers have been bitten. So please secure dogs that have an
        aggressive bark towards strangers.
      </Paragraph>

      <Paragraph>
        <b>
          11. Expect some dust, noise and general disruption of your living
          space.
        </b>
        Construction work can sometimes be messy depending upon the scope of
        your job. It’s an unfortunate reality of remodeling, but we do our best
        to keep things under control. We appreciate your patience and
        understanding during the job and until everything is finished. Even
        after we have cleaned up, it is advisable to survey the areas for
        something we may have overlooked (i.e., kids rooms, baby’s room).
      </Paragraph>

      <Paragraph>
        <b>12. *Damage to walls and old trim stops.</b>
        For those of you who have old aluminum and steel windows and are
        replacing them due to sweating and damaging of the walls be advised that
        all water damage plaster <b>will</b> most likely fall out. In addition,
        all the patch work you have done over the years will fall out also. This
        is normal; however, we are not plaster experts, so the repair to those
        walls would best be left to the experts. In some cases due to out of
        square openings, new trim is required to make the window look good.
        <b>
          *Unless noted on the contract new trim will not be provided or
          installed by us.
        </b>
        You can expect to do some touch up painting on the trim after the
        installation of your new windows. This is not always necessary and is
        usually minor if it occurs. If your trim stops around your sashes are
        very old, dry, and brittle, they may snap and crack upon removal. If
        this happens, we can leave them off if you please, or for a small up
        charge, replace them with newer ones. Many of the old style stops are no
        longer available so we would replace the entire window with newer style
        stops. Should we discover any hidden damage to the frame or wall area we
        will advise you before we proceed. Should you decide to replace or
        repair anything, the price will be added to your balance.
      </Paragraph>

      <Paragraph>
        <b>13. Relax and enjoy the show.</b>
        After we’ve been introduced to your home, feel free to run errands, take
        a walk, or just relax. If a question should arise; by all means ask the
        crew leader for clarification. We enjoy people who are interested in
        what we do, and most customers are intrigued with the process. We do get
        nervous, however, when a customer constantly hovers over our shoulder.
        Like any professional, we’re always happy to answer questions, but we
        appreciate being able to concentrate on our work without interruptions
        and distractions. This ensures a safe and quality installation.
      </Paragraph>

      <Paragraph>
        <b>
          14. Past Due Balances are subject to a service charge of 1.5% per
          month.{' '}
        </b>
        In the event that this amount is placed in the hands of an attorney for
        collection, the purchaser agrees to pay all costs of collection,
        including a reasonable attorney fee. Return check fee is $50 (fifty
        dollars).
      </Paragraph>
    </div>
  );
};

export default Content;
